import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/scss/index.scss' // 全局 css
import './assets/icons' //icon
import '@/assets/fonts/iconfont.css'
import './permission'
//elementUI
import ElementUI from 'element-ui'
import 'element-ui/packages/theme-chalk/src/index.scss'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
Vue.use(ElementUI, { locale, size: 'medium' })
// if (process.env.NODE_ENV === 'development') {
//   require('@/api/dynamicRoutes')
// }
//表单重置
import { resetForm } from '@/utils/methods'
Vue.prototype.resetForm = resetForm
// 地图
import VueAMap from 'vue-amap'
// import VueAMap from '@vuemap/vue-amap'
// import '@vuemap/vue-amap/dist/style.css'
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  // key: 'f6827f44aa49ed05dfa00bdef3c77897',  //申请的高德key
  key: 'f75e6bd59d8a85be3db09d70284810a9', //申请的高德key,web（js）
  // 插件集合
  plugin: [
    'AMap',
    'AMap.DistrictSearch',
    'AMap.DistrictLayer',
    'AMap.Autocomplete', //输入提示插件
    'AMap.PlaceSearch', //POI搜索插件
    'AMap.Scale', //右下角缩略图插件 比例尺
    'AMap.OverView', //地图鹰眼插件
    'AMap.ToolBar', //地图工具条
    'AMap.MapType', //类别切换空间，实现默认图层与卫星图，实施交通层之间切换的控制
    'AMap.PolyEditor', //编辑 折线多边形
    'AMap.CircleEditor',
    'AMap.Geocoder', //地图编码
    'AMap.Geolocation', //定位控件，用来获取和展示用户主机所在的经纬度位置
    'AMap.Geocoder', // 逆地理编码,通过经纬度获取地址所在位置详细信息
    'AMap.MarkerClusterer'
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.15'
})
window._AMapSecurityConfig = {
  //这里的安全密钥不写会导致 行政区查询等API无法使用
  securityJsCode: '8b4aeee9a5ea09148972b131faf70a06'
}
const amapKeys = Object.keys(localStorage).filter((key) => key.match(/^_AMap_/))
amapKeys.forEach((key) => {
  // console.log(key)
  localStorage.removeItem(key)
})

// echarts图表
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
